'use strict';
angular.module('PinMeTo.UI').component('pmtSpinner', {
	templateUrl: 'pmtShared/pmtUi/Spinner.html'
});
